import {ArrowForward} from '@mui/icons-material';
import {Button} from '@mui/material';

export interface SessionQuestionNavigationButtonProps {
  isAnswered: boolean;
  handleSubmitAnswer: () => void;
  handleNextQuestion: () => void;
  handleEndSession: () => void;
  isLastQuestion: boolean;
  disabled?: boolean;
}

export default function SessionQuestionNavigationButton({
  isAnswered,
  handleSubmitAnswer,
  handleNextQuestion,
  handleEndSession,
  isLastQuestion,
  disabled,
}: SessionQuestionNavigationButtonProps) {
  if (!isAnswered) {
    return (
      <Button variant="contained" onClick={handleSubmitAnswer} disabled={disabled} data-testid="submit-answer">
        Submit Answer
      </Button>
    );
  }

  return (
    <Button
      variant="contained"
      onClick={isLastQuestion ? handleEndSession : handleNextQuestion}
      disabled={disabled}
      endIcon={isLastQuestion ? null : <ArrowForward />}
      data-testid={isLastQuestion ? 'finish-session' : 'next-question'}
    >
      {isLastQuestion ? 'Finish Session' : 'Next Question'}
    </Button>
  );
}
